var ALLOWED_ATTRS = ['role', 'dir', 'hidden', 'id', 'lang', 'style', 'tabIndex', 'title'];
function getAdditionals() {
  for (var _len = arguments.length, additional = new Array(_len), _key = 0; _key < _len; _key++) {
    additional[_key] = arguments[_key];
  }
  return additional.reduce(function (acc, next) {
    if (typeof next === 'object' && !Array.isArray(next)) {
      return acc.concat(Object.keys(next).filter(function (key) {
        return !!next[key];
      }));
    } else {
      return acc.concat(next);
    }
  }, ALLOWED_ATTRS).filter(function (val, i, src) {
    return src.indexOf(val) === i;
  });
}
export default function whitelistProps() {
  var add = getAdditionals.apply(void 0, arguments);
  return function (attrs) {
    return Object.keys(attrs).reduce(function (acc, next) {
      if (add.includes(next) || /^(data-|aria-)/.test(next)) {
        acc[next] = attrs[next];
      }
      return acc;
    }, {});
  };
}